export default __webpack_public_path__ + "static/media/5.ff2083af.png";